import React from "react";
import "./Project.css";

const Project = (project) => {
  return (
    <div className="project-page">
      <div className="row-container-center">
        <video
          className="project-video"
          controls
          disablePictureInPicture
          poster={project.videoThumbnail}
        >
          <source src={project.videoUrl} type="video/mp4" />
        </video>
      </div>
      <div className="row-container">
        <div>
          <p className="project-primary-text">
            {project.category.toUpperCase()}
          </p>
        </div>
        <div>
          <p className="project-primary-text"> ⸺ </p>
        </div>
        <div>
          <p className="project-primary-text">{project.title.toUpperCase()}</p>
        </div>
      </div>
      <div className="row-container">
        <div>
          <p className="project-secondary-text">{project.description}</p>
        </div>
      </div>
      <div className="row-container">
        <div>
          <p className="project-primary-text">ROLES</p>
        </div>
        <div>
          {project.roles.map((z) => (
            <p className="project-secondary-text">{z}</p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Project;
